import { Instance, types } from 'mobx-state-tree';

export const BatchClassBatchSubjectExtraSlot = types.model('BatchClassBatchSubjectExtraSlotModel', {
  batchSubjectExtraSlotId: types.string,
  count: types.number,
});

export type BatchClassBatchSubjectExtraSlotModelType = Instance<typeof BatchClassBatchSubjectExtraSlot>;
